import {createContext} from 'react';

const PagosMedicoContext = createContext();

export default PagosMedicoContext;